// spell-checker:ignore Colorpicker
import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';

import { SkyColorpickerChangeColor } from './types/colorpicker-color';


export class SkyColorpickerTextDirective {
  
  public newColorContrast = new EventEmitter<SkyColorpickerChangeColor>();
  
  public skyColorpickerText: any;
  
  public color: string;
  
  public maxRange: number;

  
  public changeInput(event: Event) {
    let element: HTMLInputElement = <HTMLInputElement>event.target;
    let elementValue = parseFloat(element.value);
    if (this.maxRange === undefined) {
      this.newColorContrast.emit({
        color: element.value,
        colorValue: undefined,
        maxRange: undefined
      } as SkyColorpickerChangeColor);
    }

    if (!isNaN(elementValue) && elementValue >= 0 && elementValue <= this.maxRange) {
      this.newColorContrast.emit({
        color: this.color,
        colorValue: elementValue,
        maxRange: this.maxRange
      } as SkyColorpickerChangeColor);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[skyColorpickerText]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'newColorContrast': [{ type: Output },],
'skyColorpickerText': [{ type: Input },],
'color': [{ type: Input },],
'maxRange': [{ type: Input },],
'changeInput': [{ type: HostListener, args: ['input', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
